<ng-container *transloco="let t">
<tui-accordion class="tui-space_top-5 tui-space_bottom-5">
    <button tuiAccordion>{{ t('childLearn.accordion.description') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.descriptionContent.paragraph1') }}</p>
        <p class="text tui-space_bottom-3"><i><b>{{ t('childLearn.accordion.descriptionContent.quote') }}</b></i></p>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.descriptionContent.paragraph2') }}</p>
        <img src="../../../../../assets/img/scheme2.jpg" class="img-text-100" alt="">
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.descriptionContent.paragraph3') }}</p>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.descriptionContent.paragraph4') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('childLearn.accordion.verbalSigns') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.verbalSignsContent.intro') }}</p>
        
        <h4 class="tui-space_top-3 tui-space_bottom-3">
            {{ t('childLearn.accordion.verbalSignsContent.title') }}
        </h4>
        <ul class="tui-list tui-list_large tui-space_bottom-3">
            @for (item of t('childLearn.accordion.verbalSignsContent.phrases'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        
        </ul>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.verbalSignsContent.explanation') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('childLearn.accordion.physicalSigns') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.physicalSignsContent') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('childLearn.accordion.behavior') }}</button>
    <tui-expand>
        <ul class="tui-list tui-list_large">
            @for (item of t('childLearn.accordion.behaviorContent'); track item) {
                <li class="tui-list__item">{{ item }}</li>
            }
            
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('childLearn.accordion.externalManifestations') }}</button>
    <tui-expand>
        <ul class="tui-list tui-list_large">
            @for (item of t('childLearn.accordion.externalManifestationsContent'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('childLearn.accordion.functions') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.functionsContent') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('childLearn.accordion.examples') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.examplesContent.example1') }}</p>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.examplesContent.example2') }}</p>
        <p class="text tui-space_bottom-3">{{ t('childLearn.accordion.examplesContent.conclusion') }}</p>
    </tui-expand>
</tui-accordion>
</ng-container>